import { AxiosRequestHeaders } from 'axios';

export function getBearerHeader(token: string): AxiosRequestHeaders {
  return { Authorization: `Bearer ${token}` };
}

export function getBasicHeader(token: string): AxiosRequestHeaders {
  return { Authorization: `Basic ${token}` };
}
